<script>
import { Maps } from "tortilla";

export default {
    props: {
        modalData: {}
    },
    data: () => ({
        communities: []
    }),
    mounted() {
        this.findCommunities();
    },
    methods: {
        setCommunities(result) {
            this.communities = result.data.sort((a,b)=>(a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        },
        findCommunities() {
            return Tortilla.Xhr.get("/api/communities?with[]=residences").then(this.setCommunities);
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/mortgage-calculator.vue